// extracted by mini-css-extract-plugin
module.exports = {"info":"_2HFkk"};